module.exports = __webpack_public_path__ + "static/media/about-desktop-1920.13a8d368.jpg";